import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-academic-info',
  templateUrl: './academic-info.component.html',
  styleUrls: ['./academic-info.component.scss']
})
export class AcademicInfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
